export default __webpack_public_path__ + "5a538f7bbc136dd91b880d48aac99e7c.png";